import { Div, RefBool, Text } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Panel extends Div
{
    constructor(header: appendable | appendable[], body: appendable[])
    {
        super();

        const isOpen = new RefBool(true).Storable("panel:is-open:" + header);

        this.Style("padding: 1.5rem; background: #1e293b; color: #fdfdfd; border-radius: 0.5rem; margin-bottom: 16px;");
        this.Append(
            new Div().Style("display: flex; flex-direction: row; justify-content: space-between;").Append(
                !Array.isArray(header) && new Div().Append(header).FontSize(20).Bold().MarginBottom(12),
                Array.isArray(header) && new Div().Append(...header).FontSize(20).MarginBottom(12),
                body.length > 0 && new Text(isOpen, v => v ? "▼" : "▲").CursorPointer()
                    .OnClick(() => isOpen.Toggle()),
            ),
            new Div().Style("overflow: auto; margin-top: 8px;")
                .Visible(isOpen, "block")
                .Append(...body),
        );
    }
}
